module.exports = __webpack_public_path__ + "img/bg_exchange.533d9f90.png";